import axios from "axios";
import { toastr } from "react-redux-toastr";

import config from "../../config/constants";
import {
  loadProcessToken,
  showErrorToaster
} from "./index";

export const FEEDBACK_LOADING = 'FEEDBACK_LOADING';
export const LOAD_FEEDBACK_LIST = 'LOAD_FEEDBACK_LIST';
export const CREATE_FEEDBACK = 'CREATE_FEEDBACK';
export const UPDATE_FEEDBACK = 'UPDATE_FEEDBACK';
export const DELETE_FEEDBACK = 'DELETE_FEEDBACK';
export const OPEN_FEEDBACK = 'OPEN_FEEDBACK';
export const CREATE_NEW_LABEL_TOGGLE = 'CREATE_NEW_LABEL_TOGGLE';
export const GET_HEALTH_REPORT_CHART = 'GET_HEALTH_REPORT_CHART';
export const LOAD_LABEL_MANAGER = 'LOAD_LABEL_MANAGER';



const feedbackListLoading = payload => ({
  type: FEEDBACK_LOADING,
  payload,
});

export const loadFeedbackList = (props, scope) => (dispatch, getState) => {
  let token = loadProcessToken();
  dispatch(feedbackListLoading(true));
  const page = props && props.page ? props.page + 1 : 1;
  const perPage = props && props.perPage ? props.perPage : 20;
  const sortBy = props && props.sortBy ? props.sortBy : '';

  if (!props.component_id){
        console.log("Received component feedback history request without component ID");
        console.log(props);
        return
  }

  let queryString = null;
  let url = null;
  if(props) {
        if (props.filterFieldData){
            if (queryString ==null){
                queryString =  '?' + props.filterFieldData;
            } else{
                queryString =  queryString + '&' + props.filterFieldData;
            }
        }

        if (props.component_name){
            if (queryString ==null){
                queryString =  '?' + 'component_name=' + props.component_name;
            } else{
                queryString =  queryString + '&' + 'component_name=' + props.component_name;
            }
        }

        if (props.component_id){
            if (queryString ==null){
                queryString =  '?' + 'component_id=' + props.component_id;
            } else{
                queryString =  queryString + '&' + 'component_id=' + props.component_id;
            }
        }
  }

  if (queryString ==null){
        url =config.API_URL + 'ai4ai/entities/feedback?page=' + page + '&per_page=' + perPage +( sortBy && sortBy.length > 0 ? '&sort_by=' + sortBy : '' );
  } else {
        url = config.API_URL + 'ai4ai/entities/feedback' + queryString + '&page=' + page + '&per_page=' +
              perPage +( sortBy && sortBy.length > 0 ? '&sort_by=' + sortBy : '' );
  }


  axios.get(url).then(response => {
    const data = response.data;

    if (data){
      dispatch({
        type: LOAD_FEEDBACK_LIST,
        payload: { data: data.data, perPage }
      });
      dispatch(feedbackListLoading(false));
    }
  }).catch(function (error) {
    showErrorToaster(error, "Unknown Error in retrieving feedback", "Please refer the console logs for more details on the error.");
  });
};

export const createOrUpdateFeedback = (props, scope) => (dispatch, getState) => {
  let token = loadProcessToken();
  if(props._id) {
    axios.put(config.API_URL + 'ai4ai/entities/feedback', props)
      .then(({ data }) => {
        dispatch({
          type: UPDATE_FEEDBACK,
          payload: data.data
        });
        toastr.success('Successfully update the Feedback');
      }).catch(function (error) {
      showErrorToaster(error, "Unknown Error in updating feedback", "Please refer the console logs for more details on the error.");
    });
  } else {
    return axios.post(config.API_URL + 'ai4ai/entities/feedback', props)
      .then(({ data }) => {
        dispatch({
          type: CREATE_FEEDBACK,
          payload: data.data
        });
        toastr.success('Successfully created the Feedback');
      }).catch(function (error) {
        showErrorToaster(error, "Unknown Error in creating feedback", "Please refer the console logs for more details on the error.");
      });
  }
};

export  const createNewLabelToggle = ( value)  =>(dispatch, getState) => {
return  dispatch({
    type: CREATE_NEW_LABEL_TOGGLE,
    payload: value
});
}

export const createLabel = (props, scope) => (dispatch, getState) => {
  let token = loadProcessToken();
  axios.post(config.API_URL + 'ai4ai/label_manager/user', props)
      .then(({ data }) => {
        dispatch({
          type: LOAD_LABEL_MANAGER,
          payload: data.data
        });
        toastr.success('Successfully update the Feedback');
      }).catch(function (error) {
      showErrorToaster(error, "Unknown Error in updating feedback", "Please refer the console logs for more details on the error.");
  });
};

export const deleteFeedback = (props, scope) => (dispatch, getState) => {
  if(props && props._id) {
    let token = loadProcessToken();
    return axios.delete(config.API_URL + 'ai4ai/entities/feedback/' + props._id)
      .then(({ data }) => {
        dispatch({
          type: DELETE_FEEDBACK,
          payload: props._id
        });
        toastr.success('Successfully deleted the feedback');
      }).catch(function (error) {
        showErrorToaster(error, "Unknown Error in deleting feedback", "Please refer the console logs for more details on the error.");
      });
  }
};

export const openFeedback = (props, scope) => (dispatch, getState) => {
  dispatch({
    type: OPEN_FEEDBACK,
    payload: props
  });
};
